/**
 * MSAL (Microsoft Authentication Library) configuration for Azure AD SSO.
 *
 * In an Outlook add-in, the recommended flow is:
 * 1. Try SSO silently via Office.auth.getAccessToken() (Office JS SSO API)
 * 2. If that fails (consent needed, etc.), fall back to MSAL popup/redirect
 *
 * Environment variables are injected at build time via webpack DefinePlugin.
 */
import { LogLevel } from "@azure/msal-browser";
// These are injected at build time — see webpack.config.js DefinePlugin
const AZURE_CLIENT_ID = process.env.AZURE_CLIENT_ID || "";
const AZURE_TENANT_ID = process.env.AZURE_TENANT_ID || "";
const AZURE_REDIRECT_URI = process.env.AZURE_REDIRECT_URI || "https://localhost:3006/index.html";
export const msalConfig = {
    auth: {
        clientId: AZURE_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${AZURE_TENANT_ID}`,
        redirectUri: AZURE_REDIRECT_URI,
        postLogoutRedirectUri: AZURE_REDIRECT_URI,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true, // Required for IE11 / Edge Legacy in Office
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Warning,
            loggerCallback: (level, message, containsPii) => {
                if (containsPii)
                    return;
                switch (level) {
                    case LogLevel.Error:
                        console.error("[MSAL]", message);
                        break;
                    case LogLevel.Warning:
                        console.warn("[MSAL]", message);
                        break;
                    case LogLevel.Info:
                        console.info("[MSAL]", message);
                        break;
                    case LogLevel.Verbose:
                        console.debug("[MSAL]", message);
                        break;
                }
            },
        },
    },
};
/**
 * Scopes to request when acquiring a token for YOUR backend API.
 * The scope format is: api://<backend-client-id>/access_as_user
 */
export const apiScopes = AZURE_CLIENT_ID
    ? [`api://${AZURE_CLIENT_ID}/access_as_user`]
    : [];
/**
 * Scopes for Microsoft Graph (if you need user profile, mail, etc.)
 */
export const graphScopes = ["User.Read"];
/**
 * Scopes required to send a reply on the user's behalf via Microsoft Graph
 * (`POST /me/messages/{id}/replyAll`). Acquired on demand — only when the rep
 * clicks "Send Email" — so the baseline sign-in does not request mail-send
 * consent. `Mail.Send` is the delegated permission; the token is forwarded to
 * the backend for a single send and never stored.
 */
export const graphMailSendScopes = ["Mail.Send"];
